export enum SecondsDurationEnum {
	ONE_MINUTE = 60, // 60 seconds
	ONE_HOUR = 60 * 60, // 60m * 60s = 3 600 seconds
	TWO_HOUR = 2 * 60 * 60, // 2h * 60m * 60s = 7 200 seconds
	ONE_DAY = 24 * 60 * 60, // 24h * 60m * 60s = 86 400 seconds
}
